export const en = {
    'ads-description': {
        one: '{count} ad selected',
        some: '{count} ads selected',
        many: '{count} ads selected',
        none: '{count} ads selected'
    },
    'button-accept': 'Replace',
    'change-parameter': 'Replace parameter',
    'change-placeholder': 'Leaving the field empty removes the parameter',
    'change-placeholder-value': 'Leaving the field blank removes the value',
    'change-value': 'Replace value',
    'edit-site-links': 'Correct sitelinks',
    'target-parameters-placeholder': 'Exact matches only',
    'target-parameters-title': 'Find',
    'text-info':
        'You can change the name and value of parameters. In this case, the main links are not replaced. The search is only performed for exact matches.',
    title: 'Replace tracking parameters'
};
